<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.rb_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="rb_kind">
            <label class="weui-form-preview__label">{{customLabel.rb_kind || "退款单类型"}}</label>
            <em class="weui-form-preview__value">{{form.main.rb_kind}}</em>
          </div>
          <div class="weui-form-preview__item" slot="rb_custname">
            <label class="weui-form-preview__label">{{customLabel.rb_custname || "客户名称"}}</label>
            <span class="weui-form-preview__value">{{form.main.rb_custname}}</span>
          </div>
          <div class="weui-form-preview__item" slot="rb_date">
            <label class="weui-form-preview__label">{{customLabel.rb_date || "申请日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.rb_date}}</span>
          </div>
          <div class="weui-form-preview__item" slot="rb_sellername">
            <label class="weui-form-preview__label">{{customLabel.rb_sellername || "申请人"}}</label>
            <span class="weui-form-preview__value">{{form.main.rb_sellername}}</span>
          </div>
          <div class="weui-form-preview__item" slot="rb_currency"> 
            <label class="weui-form-preview__label">{{customLabel.rb_currency || "币种"}}</label>
            <span class="weui-form-preview__value">{{form.main.rb_currency}}</span>
          </div>
          <div class="weui-form-preview__item" slot="rb_amount">
            <label class="weui-form-preview__label">{{customLabel.rb_amount || "申请金额"}}</label>
            <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{form.main.rb_amount}}</span>
          </div>
          <div class="weui-form-preview__item" slot="rb_payamount">
            <label class="weui-form-preview__label">{{customLabel.rb_payamount || "已退金额"}}</label>
            <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{form.main.rb_payamount}}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.rb_text1 || '自定义字段1'"
          v-model="form.main.rb_text1" slot="rb_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.rb_text2 || '自定义字段2'"
          v-model="form.main.rb_text2" slot="rb_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.rb_text3 || '自定义字段3'"
          v-model="form.main.rb_text3" slot="rb_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.rb_text4 || '自定义字段4'"
          v-model="form.main.rb_text4" slot="rb_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.rb_text5 || '自定义字段5'"
          v-model="form.main.rb_text5" slot="rb_text5" hidden="true" />
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview" v-for="item in form.items" :key="item.id">
          <div class="form-detail-preview_num">{{item.rbd_detno}}</div>
           <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="rbd_slcode">
            <label class="weui-form-preview__label">{{customLabel.rbd_slcode || "来源单号"}}</label>
            <span class="weui-form-preview__value">{{item.rbd_slcode}}</span>
          </div>
          <div class="weui-form-preview__item" slot="rbd_seller">
            <label class="weui-form-preview__label">{{customLabel.rbd_seller || "业务员"}}</label>
            <span class="weui-form-preview__value">{{item.rbd_seller}}</span>
          </div>
          <div class="weui-form-preview__item" slot="rbd_slkind">
            <label class="weui-form-preview__label">{{customLabel.rbd_slkind || "单据类型"}}</label>
            <span class="weui-form-preview__value">{{item.rbd_slkind}}</span>
          </div>
          <div class="weui-form-preview__item" slot="rbd_sldate">
            <label class="weui-form-preview__label">{{customLabel.rbd_sldate || "单据日期"}}</label>
            <span class="weui-form-preview__value" >{{dateFormat(item.rbd_sldate,'yyyy-MM-dd')}}</span>
          </div>
          <div class="weui-form-preview__item" slot="rbd_amount">
            <label class="weui-form-preview__label">{{customLabel.rbd_amount || "单据金额"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(item.rbd_amount,'¥#,##0.00')}}</span>
          </div>
          <div class="weui-form-preview__item" slot="sl_yamount">
            <label class="weui-form-preview__label">{{customLabel.sl_yamount || "已核销金额"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(item.sl_yamount,'¥#,##0.00')}}</span>
          </div>
          <div class="weui-form-preview__item" slot="sl_namount">
            <label class="weui-form-preview__label">{{customLabel.sl_namount || "未核销金额"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(item.sl_namount,'¥#,##0.00')}}</span>
          </div>
          <div class="weui-form-preview__item" slot="rbd_nowbalance">
            <label class="weui-form-preview__label">{{customLabel.rbd_nowbalance || "本次申请金额"}}</label>
            <b><span class="weui-form-preview__value">{{numberFormat(item.rbd_nowbalance,'¥#,##0.00')}}</span></b>
          </div>
          <div class="weui-form-preview__item" slot="rbd_yamount">
            <label class="weui-form-preview__label">{{customLabel.rbd_yamount || "已退款金额"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(item.rbd_yamount,'¥#,##0.00')}}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.rbd_text1 || '自定义字段1'"
          v-model="item.rbd_text1" slot="rbd_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.rbd_text2 || '自定义字段2'"
          v-model="item.rbd_text2" slot="rbd_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.rbd_text3 || '自定义字段3'"
          v-model="item.rbd_text3" slot="rbd_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.rbd_text4 || '自定义字段4'"
          v-model="item.rbd_text4" slot="rbd_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.rbd_text5 || '自定义字段5'"
          v-model="item.rbd_text5" slot="rbd_text5" hidden="true" />
           </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.rb_remark">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{form.main.rb_remark}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">录入人</label>
            <span class="weui-form-preview__value">{{form.main.creatorName}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.rb_auditman">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{form.main.rb_auditman}}</span>
          </div>
        </div>
      </div>

      <file-list :value="form.main.rb_attach" />
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/money/recbackapply",
      caller: "RecBackApply",
      xtype: "money-recbackapply-formpanel",
    };
  }
}
</script>